import modal from "bootstrap/js/dist/modal";

function showLanguageModal() {
  const el = document.getElementById("langPrompt");
  const langPromptShown = localStorage.getItem("langPromptShown");

  if (el && langPromptShown !== "true") {
    const langModal = new modal(el);
    el.addEventListener("hide.bs.modal", languageModalClosed, { once: true });
    langModal.show();
  }
}

function languageModalClosed() {
  localStorage.setItem("langPromptShown", "true");
  const url = document.activeElement?.getAttribute("data-localUrl");
  if (url) {
    window.location.href = url;
  }
}

showLanguageModal();
